import React, { useState } from 'react';
import { Filters } from '@components';
import {
    StyledBackdrop,
    StyledButton,
    StyledDivDesktop,
    StyledDivMobile,
    StyledPaper,
    StyledSidebar,
    StyledSidebarLogosContainer,
} from './sidebar.styled';
import { TSidebar } from './sidebar.types';
import { logos } from '@constants';
import { LogosGroup } from 'components/LogosGroup';
import { Box, Fade } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useTheme } from '@material-ui/core/styles';
import { useSSRMediaQuery } from '@helpers';

export function Sidebar({
    filter,
    setFilter,
    categoryOptions,
    hideAbout,
    hideCategoriesFilters,
    hideHeader,
}: TSidebar) {
    const theme = useTheme();
    const isSmallScreen = useSSRMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useState(false);

    // Skip rendering until session is hydrated to avoid incorrect layout flashes
    if (isSmallScreen === undefined) {
        return <></>;
    }

    return (
        <Box>
            {isSmallScreen ? (
                <StyledDivMobile>
                    <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={() => setOpen(true)}
                        style={{
                            marginTop: hideHeader
                                ? theme.spacing(1)
                                : theme.spacing(7),
                        }}
                    >
                        <FilterListIcon />
                        Filters
                    </StyledButton>

                    <StyledBackdrop
                        open={open}
                        onClick={() => setOpen(false)}
                    />

                    <Fade in={open}>
                        <StyledPaper elevation={0}>
                            <Filters
                                filter={filter}
                                setFilter={setFilter}
                                categoryOptions={categoryOptions}
                                hideCategoriesFilters={hideCategoriesFilters}
                            />
                        </StyledPaper>
                    </Fade>
                </StyledDivMobile>
            ) : (
                <StyledDivDesktop>
                    <StyledSidebar>
                        <Filters
                            filter={filter}
                            setFilter={setFilter}
                            categoryOptions={categoryOptions}
                            hideCategoriesFilters={hideCategoriesFilters}
                        />
                    </StyledSidebar>
                    {!hideAbout && (
                        <StyledSidebarLogosContainer>
                            <LogosGroup
                                logos={logos.mainLogos}
                                logoWidth={'50px'}
                                smallGap
                            />
                        </StyledSidebarLogosContainer>
                    )}
                </StyledDivDesktop>
            )}
        </Box>
    );
}
